import { useState } from "react";
import axios from "axios";
import { API } from "../../App";

const HubEmailsPanel = () => {
  const [loading, setLoading] = useState(false);
  const [testLoading, setTestLoading] = useState(false);
  const [result, setResult] = useState(null);

  const authHeaders = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      "X-Frontend-Origin": window.location.origin,
    }
  });

  const handlePreview = () => {
    const token = localStorage.getItem("adminToken");
    window.open(
      `${API}/registrations/admin/email-preview`,
      "_blank"
    );
    // Need auth — open via fetch and blob instead
    fetch(`${API}/registrations/admin/email-preview`, {
      headers: { Authorization: `Bearer ${token}`, "X-Frontend-Origin": window.location.origin }
    })
      .then(r => r.text())
      .then(html => {
        const blob = new Blob([html], { type: "text/html" });
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
      });
  };

  const handleTestSend = async () => {
    setTestLoading(true);
    setResult(null);
    try {
      const res = await axios.post(`${API}/registrations/admin/send-test-email`, {}, authHeaders());
      setResult({ message: res.data.message, type: res.data.success ? "success" : "error" });
    } catch (err) {
      setResult({ message: err.response?.data?.detail || "Failed", type: "error" });
    } finally {
      setTestLoading(false);
    }
  };

  const handleSendAll = async () => {
    if (!window.confirm("Send Delegate Hub links to all completed registrations that haven't received it yet?")) return;
    setLoading(true);
    setResult(null);
    try {
      const res = await axios.post(`${API}/registrations/admin/send-hub-emails`, {}, authHeaders());
      setResult({ message: res.data.message, eligible: res.data.eligible, sent: res.data.sent, failed: res.data.failed, type: "success" });
    } catch (err) {
      setResult({ message: err.response?.data?.detail || "Failed to send emails", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-slate-800/60 rounded-xl border border-slate-700 p-6 space-y-6" data-testid="hub-emails-panel">

      {/* Preview section */}
      <div className="border border-slate-700 rounded-lg p-4 bg-slate-800/40">
        <h3 className="text-white font-semibold mb-1">Email Preview</h3>
        <p className="text-slate-400 text-sm mb-3">
          See exactly what delegates will receive — opens the sample email in a new tab.
        </p>
        <button
          onClick={handlePreview}
          className="bg-slate-600 hover:bg-slate-500 text-white text-sm font-medium px-4 py-2 rounded-lg"
          data-testid="preview-email-btn"
        >
          Preview Email
        </button>
      </div>

      {/* Test send section */}
      <div className="border border-slate-700 rounded-lg p-4 bg-slate-800/40">
        <h3 className="text-white font-semibold mb-1">Send Test Email</h3>
        <p className="text-slate-400 text-sm mb-3">
          Sends a sample welcome email to <span className="text-sky-400">libssorg@gmail.com</span> so you can check it in your inbox before the bulk send.
        </p>
        <button
          onClick={handleTestSend}
          disabled={testLoading}
          className="bg-sky-700 hover:bg-sky-600 text-white text-sm font-medium px-4 py-2 rounded-lg disabled:opacity-50"
          data-testid="test-email-btn"
        >
          {testLoading ? "Sending..." : "Send Test to Organiser Email"}
        </button>
      </div>

      {/* Bulk send section */}
      <div className="border border-slate-700 rounded-lg p-4 bg-slate-800/40">
        <h3 className="text-white font-semibold mb-1">Send to All Delegates</h3>
        <p className="text-slate-400 text-sm mb-3">
          Sends each completed registration their personal Delegate Hub link. Safe to click repeatedly — already-sent delegates are skipped.
        </p>
        <button
          onClick={handleSendAll}
          disabled={loading}
          className="bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-medium px-4 py-2 rounded-lg disabled:opacity-50"
          data-testid="send-hub-emails-btn"
        >
          {loading ? "Sending..." : "Send Hub Links to All Pending Delegates"}
        </button>
      </div>

      {result && (
        <div
          className={`rounded-lg p-4 text-sm ${result.type === "success" ? "bg-emerald-500/10 border border-emerald-500/30 text-emerald-300" : "bg-red-500/10 border border-red-500/30 text-red-300"}`}
          data-testid="hub-emails-result"
        >
          <p>{result.message}</p>
          {result.eligible !== undefined && (
            <p className="text-slate-400 mt-1 text-xs">Eligible: {result.eligible} · Sent: {result.sent} · Failed: {result.failed}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default HubEmailsPanel;
